import { ElementRef, Input, ViewChild, HostListener, OnChanges, Directive, SimpleChanges } from '@angular/core';

import { Dimensions, Serie, TooltipData, DataType, Config } from '../../../models';

@Directive()
export abstract class BaseAxisChartComponent implements OnChanges
{
    @Input() cfg: Config;
    @Input() data: any[] | DataType[];
    @Input() series: Serie[];
    @Input() hasDataPoints: boolean;
    @ViewChild('container', { static: true }) container: ElementRef;
    public config: Config;
    public xFormatTick: (date: any) => string;
    public yFormatTick: (value: number) => (string);
    public mins: number[];
    public maxs: number[];
    public dimensions: Dimensions;
    public hovered: boolean = false;
    public tooltipData: TooltipData;
    public calculatedHasDataPoints: boolean;
    public switchGridVerOn: boolean = true;
    public switchGridHorOn: boolean = true;
    public isReady: boolean;

    constructor (private elementRef: ElementRef)
    {
    }

    ngOnChanges (changes: SimpleChanges): void
    {
        if (changes.cfg.previousValue === undefined && changes.cfg.currentValue !== undefined)
        {
            this.onInit();
            this.isReady = true;
        }

        this.adjustScales();
    }

    @HostListener('window:resize')
    windowResize ()
    {
        this.adjustDimensions();
    }

    onHovered (isHovered: boolean)
    {
        this.hovered = isHovered;
    }

    onToggleSwitchGridVer = () =>
    {
        this.switchGridVerOn = !this.switchGridVerOn;
        this.config.rendering.gridVer = this.switchGridVerOn;
    };

    onToggleSwitchGridHor = () =>
    {
        this.switchGridHorOn = !this.switchGridHorOn;
        this.config.rendering.gridHor = this.switchGridHorOn;
    };
    protected abstract onInit (): void;

    public abstract adjustScales (): void;

    public calcBoundedDims (): void
    {
        this.dimensions = {
            ...this.dimensions,
            boundedWidth: Math.max(
                this.dimensions.width - this.dimensions.marginLeft - this.dimensions.marginRight,
                0
            ),
            boundedHeight: Math.max(
                this.dimensions.height - this.dimensions.marginTop - this.dimensions.marginBottom,
                0
            )
        };
        this.adjustDimensions();
    }

    public adjustDimensions (): void
    {
        const { width, height } = this.container.nativeElement.getBoundingClientRect();

        this.dimensions = {
            ...this.dimensions,
            width: width,
            height: height,
            boundedWidth: Math.max(width - this.dimensions.marginLeft - this.dimensions.marginRight, 0),
            boundedHeight: Math.max(height - this.dimensions.marginTop - this.dimensions.marginBottom, 0)
        };

        this.adjustScales();
    }
}
